const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
const addNewAlert = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_FIELD_ALERT_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'ADD_FIELD_ALERT_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default addNewAlert;